// В.2.d-2: общая утилита призыва юнита для Лив Лайф (и любых не-Глобал
// карт без attack-priority).
//
// Делегирует в существующий summonUnit из global/summon.js, но добавляет:
//   - выбор случайного свободного слота, если slot=null;
//   - возврат структуры { success, card?, line?, slot? } вместо Card|null.
//
// Семантика (как у global summon):
//   - Свежий инстанс из шаблона по cardId (через каталог в global/summon).
//   - НЕ проходит через Initiation Cooldown (initiation = 0).
//   - onUnitSummoned-хуки срабатывают: Цепь, ауры, Ликвидатор-эксперт,
//     warn-unimplemented, line-triggers и т.д.
//   - Атак-приоритет применяется только для Глобала (фракция отлична — не
//     применяется); для Лив Лайф priority берётся из template/фракционного
//     дефолта (lowest_current_hp).

import { summonUnit as baseSummonUnit } from '../global/summon.js';

// Призвать юнит cardId на сторону ownerIdx.
//   slot — { line, idx } или null (случайный свободный).
// Возвращает { success, card?, line?, slot? }.
export function summonUnitLivLife(state, cardId, ownerIdx, slot = null) {
  const p = state.players?.[ownerIdx];
  if (!p) return { success: false };
  let line, idx;
  if (slot && Number.isInteger(slot.line) && Number.isInteger(slot.idx)) {
    line = slot.line; idx = slot.idx;
    if (line < 0 || line > 1 || idx < 0 || idx > 3) return { success: false };
    if (p.field[line][idx] !== null) return { success: false };
  } else {
    const free = p.freeSlots();
    if (free.length === 0) return { success: false };
    const pick = free[state.rng.int(free.length)];
    line = pick.line; idx = pick.slot;
  }
  const card = baseSummonUnit(state, ownerIdx, cardId, line, idx, /*parentCard=*/ null);
  if (!card) return { success: false };
  return { success: true, card, line, slot: idx };
}
